import React, {useEffect} from "react";
import {connect} from 'react-redux';
import {Trans, useTranslation} from 'react-i18next';
import {Col, Card, CardBody} from 'reactstrap';
import axios from "axios";
import i18next from "i18next";

import bg from "../../assets/utils/images/bg-phone-right.png";

const rightArrowCircle = <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
    <path fill="currentColor" d="M11.999 1.993c-5.514.001-10 4.487-10 10.001s4.486 10 10.001 10c5.513 0 9.999-4.486 10-10c0-5.514-4.486-10-10.001-10.001zM12 19.994c-4.412 0-8.001-3.589-8.001-8s3.589-8 8-8.001C16.411 3.994 20 7.583 20 11.994c-.001 4.411-3.59 8-8 8z"/>
    <path fill="currentColor" d="M12 10.994H8v2h4V16l4.005-4.005L12 7.991z"/>
</svg>;

function DownloadApplication(
    {}
) {
    const {t, i18n} = useTranslation();


    useEffect(() => {
        const url = new URL(window.location.toString().replace('/#/','/'));
        if (url.href.indexOf('acceptInvite') !== -1 && url.searchParams.get('inviteToken')) {
            //нам  пришел запрос на принятие инвайта. Принимаем его и показываем тост о том что у нас все получилось, или не получилось
            let inviteToken = url.searchParams.get('inviteToken');
            acceptingAnInvite(inviteToken);
        }
    })
    const acceptingAnInvite = (jwt_token) => {

        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            headers: {
                'Content-Type': 'application/json',
            },
        });

        instance.post('auth/obtain_operator_token_v2_mobile/', {jwt_token}).then(response => {
                if (response.data.status === 'ok') {
                    Toast.show({
                        text: i18next.t('thunks.accepting_an_invite_success', 'Invitation successfully accepted')
                    });
                } else {
                    Toast.show({
                        text: response.data.error
                    });
                }
            },
            error => {
                Toast.show({
                    text: i18next.t('errors.common.request_sent', 'Error occurred during accepting invitation')
                });
            })

    };

    return <>
        <div className="h-100 z-index-1">
            <div className="d-flex h-100 justify-content-center align-items-center">
                <Col xl="6" lg="8" md="10">
                    <div className="alert alert-success" role="alert">
                        <h5 className="m-0">
                            {i18next.t('pages.acceptInvite.title', 'You have successfully accepted the invitation')}
                        </h5>
                    </div>
                    <Card>
                        <CardBody>
                            <p className="text-blue-granite">
                                {i18next.t('pages.acceptInvite.text', 'You have successfully accepted the invitation. Please download the application for\n' +'further usage. Your temporary credentinals was sent on your email.')}
                            </p>
                            <ul className="custom-ul mb-4">
                                <li>
                                    {rightArrowCircle}
                                    <div className="title mb-1">{i18next.t('pages.acceptInvite.advantages.1.title', 'Multi-Device')}</div>
                                    <p className="description text-blue-granite">{i18next.t('pages.acceptInvite.advantages.1.description', 'Sharing one WhatsApp account across multiple devices at the same time.')}</p>
                                </li>
                                <li>
                                    {rightArrowCircle}
                                    <div className="title mb-1">{i18next.t('pages.acceptInvite.advantages.2.title', 'Shared Team Inbox')}</div>
                                    <p className="description text-blue-granite">{i18next.t('pages.acceptInvite.advantages.2.description', 'Multiple agents use the same WhatsApp in real-time.')}</p>
                                </li>
                                <li>
                                    {rightArrowCircle}
                                    <div className="title mb-1">{i18next.t('pages.acceptInvite.advantages.3.title', 'Intuitive interface')}</div>
                                    <p className="description text-blue-granite">{i18next.t('pages.acceptInvite.advantages.3.description', 'Your team will easily master the simple and familiar chat interface.')}</p>
                                </li>
                            </ul>
                            <a href="https://play.google.com/store/apps/details?id=app.wabamsg.io" target="_blank" rel="nofollow">
                                <img src="/googleplay.png" alt="googleplay"
                                     className="btn-googleplay w-50"/>

                            </a>
                        </CardBody>
                    </Card>
                </Col>
            </div>
        </div>
        <img src={bg} alt="bg-phone-right" className="custom-bg-phone" />
    </>;
}


const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(DownloadApplication);
